import { render, staticRenderFns } from "./SdkReferences.vue?vue&type=template&id=bd0dc8ee&"
import script from "./SdkReferences.vue?vue&type=script&lang=js&"
export * from "./SdkReferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports